import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

/** Classic dual-trace oscilloscope with phosphor fade. */
export const scopeViz: Visualizer = {
  id: 'scope',
  label: 'Oscilloscope',
  draw(frame) {
    const { ctx, w, h, wave, bands, t } = frame;
    clearBg(ctx, w, h, 0.42);

    // CRT bezel glow
    const crt = ctx.createRadialGradient(w / 2, h / 2, Math.min(w, h) * 0.1, w / 2, h / 2, Math.min(w, h) * 0.7);
    crt.addColorStop(0, 'rgba(8, 28, 22, 0.35)');
    crt.addColorStop(1, 'rgba(2, 6, 10, 0.95)');
    ctx.fillStyle = crt;
    ctx.fillRect(0, 0, w, h);

    // grid
    ctx.strokeStyle = `rgba(86,240,200,${0.06 + bands.energy * 0.04})`;
    ctx.lineWidth = 1;
    const cols = 10;
    const rows = 6;
    for (let i = 0; i <= cols; i++) {
      const x = (i / cols) * w;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, h);
      ctx.stroke();
    }
    for (let j = 0; j <= rows; j++) {
      const y = (j / rows) * h;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(w, y);
      ctx.stroke();
    }

    const traces = [
      { y: h * 0.32, hue: 165, phase: 0, amp: 0.9 + bands.bass * 0.5 },
      { y: h * 0.68, hue: 195, phase: Math.PI * 0.35, amp: 0.7 + bands.mids * 0.6 },
    ];

    for (const tr of traces) {
      const amp = h * 0.12 * tr.amp * (0.7 + bands.energy * 0.5);
      ctx.beginPath();
      const step = Math.max(1, Math.floor(wave.length / Math.min(900, w)));
      let started = false;
      for (let i = 0; i < wave.length; i += step) {
        const x = (i / (wave.length - 1)) * w;
        const s = wave[i] || 0;
        const y =
          tr.y +
          s * amp * 14 +
          Math.sin(i * 0.04 + t * 2 + tr.phase) * amp * 0.08 * bands.highs;
        if (!started) {
          ctx.moveTo(x, y);
          started = true;
        } else ctx.lineTo(x, y);
      }
      ctx.strokeStyle = `hsla(${tr.hue + bands.highs * 25}, 95%, 62%, ${0.55 + bands.energy * 0.35})`;
      ctx.lineWidth = 1.6 + bands.kick * 1.4;
      ctx.shadowColor = `hsla(${tr.hue}, 100%, 60%, 0.7)`;
      ctx.shadowBlur = 12 + bands.beat * 16;
      ctx.stroke();
      ctx.shadowBlur = 0;

      // trigger marker
      ctx.fillStyle = `hsla(${tr.hue}, 90%, 55%, 0.5)`;
      ctx.fillRect(8, tr.y - 1, 18, 2);
    }

    // scanline
    const scanY = ((t * 40) % h);
    ctx.fillStyle = 'rgba(255,255,255,0.03)';
    ctx.fillRect(0, scanY, w, 3);

    if (bands.beat > 0.35) {
      ctx.fillStyle = `rgba(86,240,200,${0.03 * bands.beat})`;
      ctx.fillRect(0, 0, w, h);
    }
    drawHud(frame);
  },
};
